import { useState, useCallback } from "react";

import { Api } from "interfaces";
import { ApiError } from "api";

import Alert from "ui-components/Alert";
import Modal from "ui-components/Modal";
import Button from "ui-components/Button";

import { useGetDeleteProject } from "modules/projects/api";
import Divider from "ui-components/Divider";

interface Props {
  projectId: string;
}

const Delete = ({ projectId }: Props) => {
  const deleteProject = useGetDeleteProject(projectId);
  const [submitStatus, setSubmitStatus] = useState<
    "not-started" | "in-progress" | "completed"
  >("not-started");
  const [error, setError] = useState<Api.ApiError>();

  const [showModal, setShowModal] = useState(false);

  const openModal = () => {
    setShowModal(true);
    setSubmitStatus("not-started");
  };
  const closeModal = () => setShowModal(false);

  const deleteCallback = useCallback(async () => {
    setSubmitStatus("in-progress");
    try {
      await deleteProject();
      setShowModal(false);
      setSubmitStatus("completed");
    } catch (e) {
      setError(e as Api.ApiError);
    }
    setSubmitStatus("completed");
  }, [deleteProject, setShowModal, setSubmitStatus]);
  return (
    <div>
      <Button onClick={openModal} color="gray" size="small">
        DELETE
      </Button>
      <Modal
        id={`delete-${projectId}`}
        ariaLabel={`delete-${projectId}`}
        show={showModal}
        handleClose={closeModal}
        title={<>Delete {projectId}</>}
      >
        <div className="m-2 p-2">
          <p>Are you sure you want to delete?</p>
          <p>
            Note this is an irreversible operation. All data, insights and
            models associated with this project will be lost.
          </p>

          {error && (
            <div className="mt-4">
              <ApiError error={error} />
            </div>
          )}
          {submitStatus === "completed" && !error && (
            <div className="mt-4">
              <Alert variant="success">Successfully Shared!!!</Alert>
            </div>
          )}
          <Divider />
          <div className="text-right">
            <Button onClick={closeModal} color="gray">
              Exit
            </Button>
            <Button
              onClick={deleteCallback}
              loading={submitStatus === "in-progress"}
              color="danger"
            >
              Delete
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Delete;
